import { undefinedToEmptyString } from "./core.ts";

export class Logger {

    _isModeDiag: boolean;

    /// <summary>
    /// Classe de journal d'évenement.
    /// Permet d'écrire dans la console des logs.
    /// Ces logs ne sont écrit que si l'application est en mode diagnostique (débug).
    /// TOUTES LES FONCTIONS AJOUTEES DANS CETTE CLASSE DOIVENT DONC TESTER LE PARAMETRE "_isModeDiag" AVANT TOUT TRAITEMENT.
    /// </summary>
    /// <param name="debugEnabled">Options de l'uiCore indiquand si la base de donnée est en mode diagnostique (débug) </param>
    /// <history>
    ///   <entry mat="SOOZ" date="23/02/2018" task="">Création</entry>
    /// </history>
    constructor(isModeDiag) {
        this._isModeDiag = isModeDiag;
    }

    _getPageName(win) {
        /// <summary>
        /// Récupère la page sur laquelle on se trouve actuellement. Permet de tracer d'où le log est levé.
        /// </summary>
        /// <returns>
        /// Le nom de la page 
        /// </returns>
        /// <history>
        ///   <entry mat="SOOZ" date="23/02/2018" task="">Création</entry>
        /// </history>
        if (win) {
            return win.location.pathname.split("/").pop();
        }
        return "";
    }
    log(message, ...args) {
        /// <summary>
        /// Permet d'écrire dans la console le message passé en paramètre.
        /// Ajoute avant le message le nom de la page actuelle + l'heure.
        /// </summary>
        /// <param name="message">Message à écrire dans la console. (peut avoir des paramètre {1})</param>
        /// <param name="args">Tableau de paramètres à insérer dans le message, sont insérés dans le message dans l'ordre du tableau</param>
        /// <history>
        ///   <entry mat="SOOZ" date="23/02/2018" task="">Création</entry>
        /// </history>
        if (this._isModeDiag) {

            if (!Array.isArray(args)) {
                args = Array.prototype.slice.call(arguments, 1);
            }

            console.log(String.IsiFormat("{0} - {1}", [this._getDefaultMessage(), String.IsiFormat(message, args)]));
        }
    }
    /**
     * Donne le préfixe standard des messages
     * @returns
     */
    _getDefaultMessage() {
        return String.IsiFormat("[{0}] {1}", [this._getPageName(window), (new Date()).toLocaleTimeString()]);
    }

    logElem(el) {
        /// <summary>
        /// Retourne la liste des éléments dom contenus dans l'élément jQuery passé en paramètre.
        /// Les éléments sont retournés sous la forme {#id.classes.noeudDeLélémentDom, ...}
        /// </summary>
        /// <param name="el">élément jQuery à parcourir</param>
        /// <history>
        ///   <entry mat="SOOZ" date="23/02/2018" task="">Création</entry>
        /// </history>

        if (this._isModeDiag) {
            if (typeof (el) === "undefined") { return "undefined"; }
            if (el === null) { return "null"; }

            let s = "";

            var jEl = jQuery(el);
            if (jEl.length <= 0) {
                return "jQuery-empty";
            } else {
                s = jEl.length + " ";
            }

            let text = [];

            jEl.each(function (me, txt) {
                return function () {
                    let jEl = jQuery(this);
                    let id = undefinedToEmptyString(jEl.attr("id"));
                    let className = undefinedToEmptyString(jEl.attr("class"));
                    let role = undefinedToEmptyString(jEl.attr("role"));
                    let nodeName = jEl.prop("nodeName");
                    let s = "";

                    if (typeof (nodeName) === "undefined") {
                        s += "[object]";
                    } else {
                        s += nodeName;
                    }

                    if (id !== "") {
                        s += "#" + id;
                    }
                    if (className !== "") {
                        s += "." + className;
                    }
                    if (role !== "") {
                        s += " role={" + role + "}";
                    }
                    if (jEl[0].dataset) {
                        const ds = me.logStringMap(jEl[0].dataset);
                        if (ds !== "") {
                            s += " dataset=" + ds;
                        }
                    }
                    txt.push(s);
                };
            }(this, text));

            return "{" + s + text.join(", ") + "}";
        }
    }
    logStringMap(stm: any) {
        let s = "";
        if (this._isModeDiag) {
            let text = [];
            for (let i in stm) {
                text.push("" + i + ": '" + stm[i] + "'");
            }
            s = "{" + text.join(", ") + "}";
        }
        return s;
    }
    logForTreatment(treatmentInfos, message, args) {
        /// <summary>
        /// Ajoute à l'objet "treatmentInfos" passé en paramètre, le message passé en paramètre.
        /// </summary>
        /// <param name="treatmentInfos">Objet treatmentInfos dans lequel ajouter le message</param>
        /// <param name="message">Message à écrire dans la console. (peut avoir des paramètre {1})</param
        /// <param name="args">Tableau de paramètres à insérer dans le message, sont insérés dnas le message dans l'ordre du tableau</param>
        /// <history>
        ///   <entry mat="SOOZ" date="23/02/2018" task="">Création</entry>
        /// </history>

        if (this._isModeDiag) {
            if (!Array.isArray(args)) {
                args = Array.prototype.slice.call(arguments, 2);
            }
            treatmentInfos.logs.push((String.IsiFormat(message, args)));
        }
    }
    logError(msg, ex) {
        /// <summary>
        /// Permet d'ajouter à la console un message suivi du contenu de l'exception (message + stack si disponible).
        /// Le tout est ensuite ajouté à la console via la fonction log
        /// </summary>
        /// <param name="msg">message à ajouter à la console</param>
        /// <param name="ex">Exception catchée à remonter</param
        /// <history>
        ///   <entry mat="SOOZ" date="23/02/2018" task="">Création</entry>
        /// </history>

        if (this._isModeDiag) {
            let txt;
            if (ex) {
                if (ex.stack) {
                    txt = msg + " error : " + ex.message + " -> " + ex.stack;
                } else {
                    txt = msg + " error : " + ex.message;
                }
            } else {
                txt = msg;
            }
            console.error(String.IsiFormat("{0} - {1}", [this._getDefaultMessage(), txt]));
        }
    }
    logStack(txt, trim) {
        /// <summary>
        /// Ajoute via la fonction log la stack à la console. 
        /// Elle peut être préfixée d'un message.
        /// On peut également définir la taille de la stack désirée (9 par défaut)
        /// Le tout est ensuite ajouté à la console via la fonction log
        /// Cela ne fonctionne pas sous IE.
        /// </summary>
        /// <param name="txt">message à ajouter à la console</param>
        /// <param name="trim">Taille de la stack (9 par défaut)</param>
        /// <history>
        ///   <entry mat="SOOZ" date="23/02/2018" task="">Création</entry>
        /// </history>


        if (this._isModeDiag) {
            var er = new Error();

            let msg = er.stack;
            if (msg && msg != "") {
                if (!trim || trim <= 0) {
                    trim = 9;
                }
                const re = new RegExp("(.*\n){0," + trim + "}", "gm");
                let matches = msg.match(re);
                if (matches && matches.length > 0) {
                    msg = matches[0];
                }

                msg = txt + "\n" + msg;
            } else {
                msg = txt;
            }
            this.log(msg);
        }
    }
    logui(txt, jObj) {
        ///  <summary>Ecrit une trace dans la console du navigateur.</summary>
        /// <param name="txt" type="String">Text a ecrire dans le log de la console.</param>
        /// <param name="jObj" type="jQuery Object">Element jQuery relatif a la trace courante.</param>

        if (this._isModeDiag) {
            if (window.console) {
                var sLength = "";
                if (jObj && jObj != null) {
                    if (typeof (jObj.length) != "undefined") {
                        sLength = ", length=" + jObj.length;
                    } else {
                        sLength = ", pas de length !";
                    }
                }
                if (jObj && jObj != null && typeof (jObj) != "undefined" && typeof (jObj.attr) != "undefined") {
                    var s = this.logElem(jObj);

                    this.log(txt + sLength + " " + s);
                } else {
                    this.log(txt + sLength);
                }
            }
        }
    }
    logBoundingClientRect(txt, elem) {
        if (this._isModeDiag) {
            var rectObject = elem.getBoundingClientRect();
            var s = [];

            if (typeof (elem.id) != "undefined") { s.push("id:" + elem.id); }

            s.push("display:" + elem.style.getPropertyValue('display'));
            s.push("visibility:" + elem.style.getPropertyValue('visibility'));

            // bottom 	float 	Y-coordinate, relative to the viewport origin, of the bottom of the rectangle box. Read only.
            // height 	float 	Height of the rectangle box (This is identical to bottom minus top). Read only.
            // left 	float 	X-coordinate, relative to the viewport origin, of the left of the rectangle box. Read only.
            // right 	float 	X-coordinate, relative to the viewport origin, of the right of the rectangle box. Read only.
            // top 	    float 	Y-coordinate, relative to the viewport origin, of the top of the rectangle box. Read only.
            // width 	float 	Width of the rectangle box (This is identical to right minus left). Read only.
            // x 	    float 	X-coordinate, relative to the viewport origin, of the left of the rectangle box. Read only.
            // y        float 	Y-coordinate, relative to the viewport origin, of the top of the rectangle box. Read only.

            if (typeof (rectObject.top) != "undefined") { s.push("top:" + rectObject.top); }
            if (typeof (rectObject.bottom) != "undefined") { s.push("bottom:" + rectObject.bottom); }
            if (typeof (rectObject.left) != "undefined") { s.push("left:" + rectObject.left); }
            if (typeof (rectObject.right) != "undefined") { s.push("right:" + rectObject.right); }
            if (typeof (rectObject.height) != "undefined") { s.push("height:" + rectObject.height); }
            if (typeof (rectObject.width) != "undefined") { s.push("width:" + rectObject.width); }
            if (typeof (rectObject.x) != "undefined") { s.push("x:" + rectObject.x); }
            if (typeof (rectObject.y) != "undefined") { s.push("y:" + rectObject.y); }

            this.log(txt + " " + s.join(", "));
        }
    }

    logObj(obj) {
        /// <summary>
        /// Permet d'écrire dans la console l'objet passé en paramètre.
        /// </summary>
        /// <param name="message">Objet à envoyer dans la console.</param>
        if (this._isModeDiag) {
            console.log(obj);
        }
    }

}